const Main = () => import('./views/index.vue');

export default [
  {
    name: 'main',
    path: '/main/*',
    component: Main,
    meta: { title: '风变科技' }
  }
];
